'use strict';

angular.module('app.notificationLogin', [])

.controller('notificationLoginCtrl', ['$http', '$state', 'ipCookie', '$scope', '$rootScope', '$location', '$stateParams', 'localStorageService', 'AuthenticationService', 
    function ($http, $state, ipCookie, $scope, $rootScope, $location, $stateParams, localStorageService, AuthenticationService) {
        $scope.dataLoading = true;
        $scope.Autologin = function () {
                       
            AuthenticationService.Logout();
            window.Intercom("shutdown");
            $http.get($rootScope.apiUrl + 'notification/notificationLogin/' + encodeURIComponent($stateParams.hashedPassword))
            .success(function(data){

                localStorageService.set('access_token', data.Authorization);

                var et = data.expiration_time;
                var expirationDate = new Date(et.split(' ').join('T'));
                var expirationSeconds = (expirationDate.getTime() / 1000) - Math.floor(Date.now() / 1000);

                if (localStorageService.cookie.isSupported) {
                    ipCookie("access_token_expiration", et, {
                        expirationUnit: 'seconds',
                        expires: expirationSeconds
                    });
                } else {
                    localStorageService.set('access_token_expiration', et, 'memory');
                }

                AuthenticationService.getCurrentUser($scope.dataLoading);
            })
            .error(function(data, status) {
                $location.path('/login');
            });
        };

        $scope.Autologin();
}])

